module.exports = __webpack_public_path__ + "img/Weapon_272.a74b6e2c.png";